import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RootState } from "../../../../redux/reducers/root.reducer";
import { OfferState } from "../../../../redux/reducers/offer.reducer";
import { AuthState } from "../../../../redux/reducers/auth.reducer";
import { useEffect, useState } from "react";
import { setSelectedOffer } from "../../../../redux/actions/offer.action";
import { motion } from "framer-motion";
import { Button } from "../../../../components/Button";
import { IconButton } from "../../../../components/IconButton";
import { RequestDetailsSection } from "../../../../components/RequestDetailsSection";
import { Helmet } from "react-helmet-async";
import { RequestsState } from "../../../../redux/reducers/requests.reducer";
import clsx from "clsx";

import {
  ArrowLeft,
  PlusCircle as PlusCircleIcon,
  SkipBack,
  X,
} from "react-feather";

export const PlaintiffDetailsRequest = () => {
  const navigation = useNavigate();

  const { selected: selectedRequest, searchOffer } = useSelector<
    RootState,
    RequestsState
  >((state) => state.requestReducer);
  const { selected: selectedOffer } = useSelector<RootState, OfferState>(
    (state) => state.offerReducer
  );

  const { user } = useSelector<RootState, AuthState>(
    (state) => state.authReducer
  );

  const [actualWidth, setActualWidth] = useState(window.innerWidth);

  const resizeHandler = () => {
    const width = window.innerWidth;

    setActualWidth(width);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeHandler);
  }, []);

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="py-0 sm:px-6 lg:px-14 px-4 lg:py-14"
    >
      <Helmet title="Detalle Solicitud" />

      <IconButton onClick={() => navigation("/demandante/otrasSolicitudes")}>
        <ArrowLeft size={32} className="text-secondary" />
      </IconButton>

      {selectedRequest ? (
        <div className="grid sm:grid-cols-1 gap-4">
          <div>
            <RequestDetailsSection request={selectedRequest} />
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </motion.main>
  );
};
